import styled from "@emotion/styled";
import { Box, Card, Paper } from "@mui/material";

export const HeaderPaper = styled(Paper)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;
    padding: 1.5rem;
    border-radius: 24px;
    flex-wrap: wrap;
`;

export const IdentidadeBox = styled(Box)`
    display: flex;
    align-items: center;
    gap: 1rem;
    min-width: 0;
`;

export const MonogramaBox = styled(Box)`
    width: 56px;
    height: 56px;
    border-radius: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-weight: 700;
    font-size: 1.25rem;
    color: ${props => props.theme.palette.common.white};
    background: ${props => props.theme.palette.primary.main};
`;

export const IndicadoresBox = styled(Box)`
    display: flex;
    gap: 2rem;
    flex-wrap: wrap;
`;

export const IndicadorBox = styled(Box)`
    min-width: 96px;
`;

/**
 * Card de estabelecimento. A borda esquerda colorida carrega a situação, para
 * o bloqueio ser visível antes de ler qualquer texto.
 *
 * `statusColor` fica fora do DOM: o styled repassa props desconhecidas para o
 * Card, e o React reclamaria de um atributo inválido no <div>.
 */
export const EstabelecimentoCard = styled(Card, {
    shouldForwardProp: prop => prop !== "statusColor"
})<{ statusColor: string }>`
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    border-left: 4px solid ${props => props.statusColor};
    transition: box-shadow 0.25s, transform 0.25s;

    &:hover {
        box-shadow: 0 10px 28px rgba(0, 0, 0, 0.12);
        transform: translateY(-2px);
    }
`;

export const LogoBox = styled(Box)`
    width: 48px;
    height: 48px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background-color: ${props => props.theme.palette.divider};
`;

export const ToolbarBox = styled(Box)`
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
    margin: 1.5rem 0 1rem;
`;

export const VazioBox = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
    padding: 3rem 1.5rem;
    text-align: center;
`;

/** Bloco de conteúdo do card que cresce, para os rodapés ficarem alinhados. */
export const CorpoCardBox = styled(Box)`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    flex: 1;
    padding: 1.25rem 1.25rem 0.75rem;
`;

export const RodapeCardBox = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    padding: 0.5rem 0.75rem 0.75rem 1.25rem;
`;
